import React, {
  useEffect,
} from 'react';
import compact from 'lodash/compact';
import {
  useMedia,
} from 'core/hooks';
import {
  MediaOriginatorType,
} from 'pages/Dashboard/utils/constants';
import {
  useGetRefundLogs,
} from 'views/EMR/hooks/billing';
import Table from 'core/components/VirtualTable';
import {
  ColumnDef,
} from '@tanstack/react-table';
import refundLogsColumns from 'views/EMR/Billing/AdjustPayment/RefundLogsColumn';
import {
  RefundRow,
} from 'views/EMR/Billing/utils';
import isNil from 'lodash/isNil';

type Props = {
  patientId: number;
  maxHeight: number | null;
};

export default function RefundLogs({
  patientId,
  maxHeight,
}: Props) {
  const { data, isLoading } = useGetRefundLogs(patientId);
  const { requestMedia } = useMedia();

  useEffect(() => {
    if (!isNil(data)) {
      const userIds = compact(data.map(({ refundedByUserId }) => refundedByUserId));
      if (userIds.length > 0) {
        requestMedia(userIds, MediaOriginatorType.User);
      }
    }
  }, [data, requestMedia]);

  return (
    <div className="flex relative w-full !overflow-auto p-4" style={{ maxHeight: `${maxHeight}px` }}>
      <div className="flex flex-1 flex-col w-full move-to-credit-table">
        <Table<RefundRow>
          columns={refundLogsColumns as ColumnDef<RefundRow>[]}
          data={data ?? []}
          emptySlot="No refund history found."
          skeleton={{ rows: 3 }}
          loading={isLoading}
          classes={{
            body: '!m-0 !p-0 !bg-white',
            scrollContainer: '!p-0',
            column: '!text-left',
            outerHeader: '!bg-gray-100 !border !border-gray-200 !rounded-sm',
            header: '!text-gray-700 !py-2 !border-0',
            row: '!h-10',
            outerRow: '!w-full',
            scrollbarGutter: 'inherit',
            windowsClassName: '!w-full',
          }}
        />
      </div>
    </div>
  );
}
